import styled, { css } from 'styled-components';
import { LoginButtonProps } from './LoginButton';

export const Element = styled.div<LoginButtonProps>`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      flex-grow: 0;
      width: 100%;
      align-items: center;
      gap: 1rem;
      > * {
        flex-grow: 0;
        flex-shrink: 0;
      }

      a {
        text-decoration: underline;
      }
    `;
  }};
`;
